export const FETCH_ALPINESKIING_LISTING = "FETCH_ALPINESKIING_LISTING";
export const FETCH_ALPINESKIING_LISTING_BEGIN = "FETCH_ALPINESKIING_LISTING_BEGIN";
export const FETCH_ALPINESKIING_LISTING_SUCCESS = "FETCH_ALPINESKIING_LISTING_SUCCESS";
export const FETCH_ALPINESKIING_LISTING_ERROR = "FETCH_ALPINESKIING_LISTING_ERROR";

export const FETCH_ALPINESKIING_RANKING = "FETCH_ALPINESKIING_RANKING";
export const FETCH_ALPINESKIING_RANKING_BEGIN = "FETCH_ALPINESKIING_RANKING_BEGIN";
export const FETCH_ALPINESKIING_RANKING_SUCCESS = "FETCH_ALPINESKIING_RANKING_SUCCESS";
export const FETCH_ALPINESKIING_RANKING_ERROR = "FETCH_ALPINESKIING_RANKING_ERROR";
